export default{
  userId : localStorage.getItem('algerieDok-U') || null,
  user : localStorage.getItem('email') || null,
  cloudinaryUrl: "https://res.cloudinary.com/dba2dcapc/image/upload/v1611178444/",
  token:localStorage.getItem('algerieDok-T') || null,
  role:localStorage.getItem('algerieDok-R') || null
}
